import DashboardLayout from '@/views/Layout/DashboardLayout.vue';
import AuthLayout from '@/views/Pages/AuthLayout.vue';
// GeneralViews
import NotFound from '@/views/GeneralViews/NotFoundPage.vue';


// Dashboard pages
const Dashboard = () => import(/* webpackChunkName: "dashboard" */ '@/views/Dashboard/Dashboard.vue');
const Login = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Login.vue');
const Settings = () => import(/* webpackChunkName: "pages" */ '@/views/Settings/Settings.vue');
const Keywords = () => import(/* webpackChunkName: "pages" */ '@/views/Settings/Keywords.vue');


let authPages = {
  path: '/users',
  component: AuthLayout,
  name: 'Authentication',
  children: [
  
    {
      path: 'login',
      name: 'Login',
      component: Login
    },
    { path: '*', component: NotFound }
  ]
};

const routes = [
 


  {
    path: '/',
    component: DashboardLayout,
    redirect: '/dashboard',
    name: 'Dashboard layout',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: Dashboard
      },
      {
        path: 'dashboard/:id',
        name: 'DashboardProject',
        component: Dashboard
      },
      {
        path: 'settings',
        name: 'Settings',
        component: Settings
      },
      {
        path: 'keywords',
        name: 'keywords',
        component: Keywords
      }
    ]
  },

  authPages,
];

export default routes;
